import {queryOptions} from '@tanstack/react-query'
import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/react-start'
import {z} from 'zod'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 * 24 // 24h

const LOCALE_MAP: Partial<Record<Locale, () => Promise<Record<string, any>>>> = {
    en_EU: () => import('../../../public/translations/en.json'),
    de_DE: () => import('../../../public/translations/de.json'),
}

const translationParams = z.object({
    locale: z.nativeEnum(Locale),
})

const getTranslations = createServerFn({
    method: 'GET',
})
    .inputValidator((data: unknown) => {
        const result = translationParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }

        return result.data
    })
    .handler(async ({data}) => {
        const getTranslations = LOCALE_MAP[data.locale]

        if (!getTranslations) {
            throw notFound()
        }

        const translations = await getTranslations()

        applyServerFnCache(CACHE_TIME_SEC)

        return translations
    })

export const translationsQueryOptions = (locale: Locale) =>
    queryOptions({
        queryKey: ['translations', locale],
        queryFn: () => getTranslations({data: {locale}}),
        gcTime: 1000 * CACHE_TIME_SEC, // 24h
        staleTime: 1000 * CACHE_TIME_SEC, // 24h
    })
